// components/artifacts/charts/FunnelChartComponent.tsx
import React from "react";
import { FunnelChart, Funnel, Cell } from "recharts";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { GraphData } from "@/types/Artifact";
import { formatNumber } from "@/lib/utils";

interface FunnelChartComponentProps {
  data: GraphData;
  config: Record<string, any>;
  colors: string[];
  id?: string;
}

// Custom tooltip formatter that includes units
const formatTooltipValue = (value: any, unit?: string) => {
  let y = value
  //if value is number, convert to string
  if (typeof value === 'number') {
    y = formatNumber(y);
  } 

  if (!unit) return value;
  
  // Handle different unit types
  switch (unit) {
    case '$':
    case '€':
    case '£':
    case '¥':
      return `${unit}${y}`;
    case '%':
      return `${y}${unit}`;
    default:
      return `${y} ${unit}`;
  }
};

export const FunnelChartComponent: React.FC<FunnelChartComponentProps> = React.memo(({
  data,
  config,
  colors,
  id,
}) => {
  const valueKey = data.valueKey || "value";
  const categoryKey = data.categoryKey || "category";
  const { valueUnit } = data;

  return (
    <div className="p-4" id={id}>
      {/* Display unit information if available */}
      {/* {valueUnit && (
        <div className="mb-2 text-sm text-muted-foreground">
          Values: {valueUnit}
        </div>
      )} */}
      
      <ChartContainer
        config={config}
        className="max-h-[calc(100vh-10rem)] min-h-[400px] w-full"
      >
        <FunnelChart>
          <ChartTooltip 
            content={<ChartTooltipContent 
              valueFormatter={(value) => formatTooltipValue(value, valueUnit)}
            />} 
          />
          <Funnel 
            dataKey={valueKey} 
            nameKey={categoryKey} 
            data={data.data}
            isAnimationActive={true}
          >
            {data.data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Funnel>
        </FunnelChart>
      </ChartContainer>
    </div>
  );
});